import { DetailPageClientContext } from 'components/desktop/detail';
import { IconChevronDown, IconNotepadPerson } from 'components/icons';
import { gt } from 'lodash';
import { useContext, useEffect, useState } from 'react';

const MAX_HEIGH_PARAGRAPH = 114;

const PrivateNote = () => {
  const { realEstate } = useContext(DetailPageClientContext).pageData ?? {};
  const { privateNote } = realEstate ?? {};
  const [isShowMore, setIsShowMore] = useState(false);
  const [clientHeight, setClientHeight] = useState<number>();
  const hasShowMore = gt(clientHeight, MAX_HEIGH_PARAGRAPH);

  const showMore = () => {
    setIsShowMore(!isShowMore);
  };

  useEffect(() => {
    setClientHeight(document.getElementById('private-note-paragraph')?.clientHeight);
  }, [privateNote]);

  return privateNote ? (
    <div id='private-note' className='flex flex-col space-y-[20px] rounded-[15px] bg-note p-[12px]'>
      <div className='flex items-center space-x-[10px]'>
        <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-paper'>
          <IconNotepadPerson className='h-[18px] w-[18px]' />
        </div>
        <h2 className='text-[18px] font-[600] leading-[23px]'>Ghi chú cá nhân</h2>
      </div>
      <div className='flex flex-col items-center space-y-[4px]'>
        <div
          className={`w-full truncate whitespace-pre-wrap leading-[20px] ${
            hasShowMore && isShowMore ? 'line-clamp-[5]' : ''
          }`}
          dangerouslySetInnerHTML={{ __html: privateNote }}
        />
        {hasShowMore && (
          <button
            type='button'
            className='flex h-[25px] items-center space-x-[4px] text-primary'
            onClick={showMore}
          >
            <span>{isShowMore ? 'Xem thêm' : 'Ẩn bớt'}</span>
            <IconChevronDown
              className={`h-[16px] w-[16px] transition duration-[200ms] ease-in-out ${
                isShowMore ? '' : 'rotate-180'
              }`}
            />
          </button>
        )}
      </div>
    </div>
  ) : null;
};

export default PrivateNote;
